export const DATEFORMAT = 'MM/DD/YYYY';
export const TIMEFORMAT = 'hh:mm:ss A';
export const FULL_DATE_FORMAT = 'MMMM DD, YYYY';

export enum Platform {
  DASHBOARD = 'DASHBOARD',
  SLACK = 'SLACK',
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  TEAMS = 'TEAMS',
  API = 'API',
  SDK_ANDROID = 'SDK_ANDROID',
  SDK_IOS = 'SDK_IOS',
}

export enum AccessType {
  SHARED = 'SHARED',
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum ShareType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum DocumentType {
  FAVORITE = 'FAVORITE',
  OWNED = 'OWNED',
  SHARED = 'SHARED',
}

export enum AccessTypeOptions {
  SHARED = 'Shared',
  PUBLIC = 'Public',
  PRIVATE = 'Private',
}
